import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import withLocalized from 'modules/localization/withLocalized'
import { media } from 'modules/common/components/ui/utils'
import colors from 'modules/common/components/ui/colors'

const LinksList = styled.ul`
  text-transform: uppercase;
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 15px
  ${media.maxWidth(1199)`
    li:first-child{
      padding-top: 22px;
    }
  `}
  ${media.minWidth(1200)`
    display: flex;
    align-items: stretch;
    height: calc(80rem / 16);
    margin-left: 15px;
    margin-right: 30px;
    border-top: 0;
  `}
  a {
    color: white;
    display: flex;
    align-items: center;
    padding-top: 12px;
    border-bottom: 12px solid transparent;
    ${media.maxWidth(1199)`
      display: inline-block;
      justify-content: center;
      padding-top: 8px;
      padding-bottom: 2px;
      border-bottom-width: 2px;
    `}
    &:hover{
      color: ${({theme = {}}) => theme.NavigationHighlightColor };
    }
    &.active {
      color: ${({theme = {}}) => theme.NavigationHighlightColor };
      border-color: ${({theme = {}}) => theme.NavigationHighlightColor };
      /* background: ${({theme = {}}) => theme.NavigationHighlightColor }; */
    }
  }
  .menu--sub{
    margin: 0;
    padding: 0;
    list-style: none;
    > li{
      border-top: 0;
    }
    ${media.maxWidth(1199)`
      display: flex;
      flex-wrap: wrap;
      font-size: 13px;
      padding-top: 5px;
      padding-bottom: 5px;
      > li{
        padding: 0;
        width: 100%;
        align-items: center;

        a{
          &.active{
            border-bottom-color: transparent;
          }
        }
      }
    `}
    ${media.minWidth(1200)`
      position: absolute;
      top: calc(80rem / 16);
      height: calc(60rem / 16);
      left: 0;
      right: 0;
      padding-left: 30px;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: stretch;
      a{
        padding-top: 6px;
        border-bottom-width: 6px;
      }
    `}
  }
`;

const Li = styled.li`
  border-bottom: 1px solid ${colors.BORDER_COLOR};
  display: flex;
  line-height: 1em;
  padding: 0 calc(15rem / 16);
  text-align: center;
  border-bottom: 0;
  border-top: 1px solid #4a4a4a;
  ${({login}) =>  login && `
    align-items: center;
    margin-left: auto;
    
  `}
  .btn--login{
    border: 1px solid ${({theme = {}}) => theme.NavigationHighlightColor };
    color:  ${({theme = {}}) => theme.NavigationHighlightColor };
    padding: 0 34px;
    height: 40px;
    border-radius: 2px;
    font-size: 14px;
    display: flex;
    width: 100%;
    max-width: 400px;
    &:hover{
      color: white;
      border-color: white;
    }
  }
  ${media.maxWidth(1199)`
    flex-direction: column;
    padding: 22px 15px;
    text-align: center;
    align-items: center;
    &.menu-item--open{
      background-color: #1b1b1b;
    }
    ${({login}) =>  login && `
      padding-top: 40px;
      margin-left: 0;
    `}
  `}
`

const NavigationLinks = props => {
  const { 
    localized,
   } = props;
    return (
      <LinksList>
        <Li>
          <a href={localized('nav.classes_link')}>{localized('nav.classes')}</a>
        </Li>
        { (process.env.REACT_APP_LOCALE === 'en') && 
          <Li>
            <a href={localized('nav.coaches_link')}>{localized('nav.coaches')}</a>
          </Li>
        }
        <Li login>
          <a href="https://www.birdietime.tv/sign_in" className="btn--login">
            LOG IN TO CLASSES
          </a>
        </Li>
      </LinksList>
    );
};

//export default withRouter(NavigationLinks);
export default withLocalized(withRouter(NavigationLinks));



// WEBPACK FOOTER //
// ./src/modules/common/components/app/navigation/NavigationLinks.js